// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f65849c8","977":"bee41565"}[chunkId] + ".chunk.js";
};